import { render, staticRenderFns } from "./WalletAdd.vue?vue&type=template&id=64d63aba&scoped=true&"
import script from "./WalletAdd.vue?vue&type=script&lang=js&"
export * from "./WalletAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d63aba",
  null
  
)

export default component.exports